import { IClinic } from '../interfaces/clinic';
import { CommonService } from '../services/common';

export const getClinicsForSelect = async (filter?: { ids?: number[] }): Promise<IClinic[]> => {
  const response = await CommonService.getClinics();
  const mapResponse = response
    .filter((clinic) => {
      if (filter?.ids) {
        return filter.ids.includes(clinic.id);
      }
      return true;
    })
    .sort((a, b) => a.id - b.id);
  return mapResponse;
};

export const getClinicNameByClinicId = (clinicId: number, clinics: IClinic[]) => {
  const clinic = clinics.find((clinic) => clinic.id === clinicId);

  return clinic?.name ?? 'unknown';
};
